import CommandInterceptor from 'diagram-js/lib/command/CommandInterceptor';
import EventBus from 'diagram-js/lib/core/EventBus';
import {UserInitiatedCommandType} from '@ispm/shared/bpmn-io/bpmn-js';
import { Store } from '@ngrx/store';
import { State } from '../../store/state';
import { AddUnsavedAction } from '../../store/actions/user-initiated-actions.actions';
import { CommandStackAction } from '@ispm/shared/bpmn-io/commandstack-action';
import { filter, take } from 'rxjs/operators';
import { lastUnsavedUserInitiatedActionId } from '@ispm-client/modules/bpmn-modeler/store/selectors/user-initiated-actions.selector';

export class ActionExecuteBehavior extends CommandInterceptor {


  constructor(eventBus: EventBus, private store$: Store<State>) {
    super(eventBus);
    Object.keys(UserInitiatedCommandType).map(key => {
      super.postExecute([UserInitiatedCommandType[key]], (command: CommandStackAction) => {
          this.store$.select(lastUnsavedUserInitiatedActionId).pipe(
            take(1),
            filter(id => id !== command.id)
          ).subscribe(() => this.store$.dispatch(new AddUnsavedAction(command)));
      });
    }
    );
  }

 
}

ActionExecuteBehavior.$inject = [...CommandInterceptor.$inject, 'store$'];
